import React, { Component } from 'react';
import DataAPI from '../../../Utils/Api';
import TimeUtil from '../../../Utils/TimeUtil';
import StarRatingComponent from "react-star-rating-component";


interface IState {
    surveys,
    rating,
    response
}

class Surveys extends Component<{}, IState> {
    constructor(props) {
        super(props);
        this.state = {
            surveys: [],
            rating: [],
            response: [],
        }
    }

    getAllSurverys() {
        DataAPI().post('/GetSurvey',{})
        .then((response) => {
            this.setState({ surveys: response.data })
            var toPush = {};
            this.state.surveys.map((survey, index) => {
                survey.surveyReponseDtos.map((sur, index) => {
                    var starname = "rating" + sur.survey_parameters;
                    toPush["" + starname + ""] = 0;
                });
            });
            this.setState({
                rating: toPush
            })
        })
        .catch((error) => {
            console.log(error);
        })
    }

    componentDidMount() {
        //this.getAllSurverys();
    }

    onStarClick(nextValue, prevValue, name) {
        let stateCopy = JSON.parse(JSON.stringify(this.state.rating));
        stateCopy[name] = nextValue;
        this.setState({
          rating: stateCopy
        });
        this.rated(name.toString(), nextValue.toString());
    }

    rated(pid, res) {
        var responseObj = new Object();
        responseObj["surveyParameterId"] = pid.toString();
        responseObj["surveyResponse"] = res;
        this.state.response.push(responseObj);
    }

    surveySubmit(id, userid) {
        DataAPI().post('/DeleteSurvey',{
            userId: userid,
            surveyId: id.toString(),
            surveyResponse: this.state.response
        })
        .then((response) => {
            if (response.data.response === "Success") {
                this.getAllSurverys();
            }
        })
        .catch((error) => {
            console.log(error);
        })
    }


    render() {
        return (
            <React.Fragment>
                <span style={{ color: "#367feb", fontSize: "15px" }}>({this.state.surveys.length})</span>
                {this.state.surveys.map((e, i) => {
                    return (
                        <div className="sf-each-offer" key={i}>
                            <div style={{ display: "inline-block", width: "220px" }}>
                                <span style={{ fontSize: "16px", color: "#6e6e6e" }}>
                                    {e.survey_description}
                                </span>
                                <br />
                                {e.surveyReponseDtos.map((sur, index) => {
                                    var sur_param = sur.survey_parameters;
                                    var star_name = sur.survey_parameters_id;
                                    return (
                                        <div key={index}>
                                            <span style={{ fontSize: "14px", color: "#6e6e6e", marginRight: "50px" }}>
                                                {sur.survey_parameters}
                                            </span>
                                            <StarRatingComponent
                                                name={star_name}
                                                editing={true}
                                                starCount={5}
                                                value={this.state.rating[star_name]}
                                                onStarClick={this.onStarClick.bind(this)}
                                            />
                                        </div>
                                    )
                                    
                                })}
                                <button
                                    className="poll-submit-button"
                                    onClick={this.surveySubmit.bind(this, e.survey_id, e.userId)}
                                    >
                                    Submit
                                </button>
                                
                            </div>
                            <span style={{ fontSize: "8px", float: "right" }}>{TimeUtil.getCurrentTime(new Date())}</span>
                        </div>
                    )
                })}
            </React.Fragment>
        );
    }
}

export default Surveys;